export default __webpack_public_path__ + "static/media/squares500.b26a6a38.jpg";